import { useEffect, useState } from "react";

export function useVersionChecker(interval = 60000) {
  const [hasNewVersion, setHasNewVersion] = useState(false);
  useEffect(() => {
    let currentVersion = null;
    const checkVersion = async () => {
      try {
        const response = await fetch(`/version.json?_=${Date.now()}`, { cache: "no-store" });
        const data = await response.json();
        if (!currentVersion) currentVersion = data.version;
        else if (data.version !== currentVersion) setHasNewVersion(true);
      } catch (e) {
        console.error("Version check failed:", e);
      }
    };
    checkVersion();
    const id = setInterval(checkVersion, interval);
    window.addEventListener("focus", checkVersion);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", checkVersion);
    };
  }, [interval]);
  return hasNewVersion;
}

